import type { RouteRecordRaw } from '@fusapp-work/shell'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
  /**
   * FW-97 — kurulum sihirbazi. `meta.standalone` App.vue'ya bu rotanin
   * genel AppShell/FwSurfaceCard kabugunu (baslik+kart) ALMAYACAGINI
   * soyler: tasarim (design/current/Onboarding.dc.html) kendi tam-viewport
   * ust seridini + sol adim rayini tasir, genel kabukla cakisir (bkz.
   * OnboardingView.vue basligi — apps/auth'un App.vue'daki AYNI gerekcesi).
   */
  {
    path: '/kurulum',
    name: 'onboarding',
    component: () => import('../views/OnboardingView.vue'),
    meta: { standalone: true },
  },
]
